import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Login from '../components/Login'
import Agent from '../components/Agent.vue'
import Interface from '../components/Interface'
import Introduce from '../components/Introduce'
import Inspiration from '../components/Inspiration'
import Consultative from '../components/Consultative'
import Faq from '../components/Faq'
import FaqDetail from '../components/FaqDetail'
import User from '../components/User'
import Service from '../components/Service'
import ChinaIpGoods from '../components/ChinaIpGoods'
import AbroadIpGoods from '../components/AbroadIpGoods'
// import TestPage from '../components/TestPage.vue'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/pc/' : '/',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {

            path: '/agent',
            name: 'Agent',
            component: Agent,
            meta: {
                isShow: true
            }
        },
        {

            path: '/rzNotice',
            name: 'rzNotice',
            component: ()=>import('@/components/rzNotice.vue'),
            meta: {
                isShow: true
            }
        },
        {

            path: '/pay-status',
            name: 'PayStatus',
            component: ()=>import('../components/PayStatus.vue'),
            meta: {
                isShow: true
            }
        },

        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                isShow: false,
                isFooter:false,
            }
        },
        {
            path: '/interface',
            name: 'Interface',
            component: Interface,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/introduce',
            name: 'Introduce',
            component: Introduce,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/inspiration',
            name: 'Inspiration',
            component: Inspiration,
            meta: {
                isShow: true
            }
        },
        {
            path: '/consultative',
            name: 'Consultative',
            component: Consultative,
            meta: {
                isShow: false
            }
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/faqDetail',
            name: 'FaqDetail',
            component: FaqDetail,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/abroad-ip-goods',
            name: 'AbroadIpGoods',
            component: AbroadIpGoods,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/user',
            name: 'User',
            component: User,
            meta: {
                isShow: true,
                isFooter:false,

            }
        },
        {
            path: '/service',
            name: 'Service',
            component: Service,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        {
            path: '/china-ip-goods',
            name: 'ChinaIpGoods',
            // eslint-disable-next-line no-undef
            component: ChinaIpGoods,
            meta: {
                isShow: true,
                isFooter:true,
            }
        },
        // {
        //     path: '/test',
        //     name: 'TestPage',
        //     component: TestPage,
        //     meta: {
        //         isShow: true,
        //         isFooter:false,
        //     }
        // },

    ],
    scrollBehavior() {
        //x代表横坐标，y代表纵坐标
        return { x: 0,y: 0 };
    }
})

// 添加路由调试
router.beforeEach((to, from, next) => {
    // eslint-disable-next-line no-console
    console.log('路由跳转:', to.path, 'from:', from.path)
    // eslint-disable-next-line no-console
    console.log('当前环境:', process.env.NODE_ENV)
    // eslint-disable-next-line no-console
    console.log('路由base:', router.options.base)
    next()
})

export default router
